import notesContext from "./notesContext";
import { useState,useEffect } from "react";

const NoteState = (props) => {
 
 
  // const url = "http://localhost:5000"

  const url = "https://backened-8u4s2zadi-jharaghav3209-gmailcom.vercel.app"
  
  const notesInit = []
  const [token, setToken] = useState(null);

  const [notes, setNotes] = useState(notesInit)
  useEffect(()=>{
    fetchNote();
    console.log('calling useeffect')
   },[notes])
  // function to add a note
  const addNote = async (title, description, tag) => {
    //API CALL
    const response = await fetch(`${url}/api/notes/addnotes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
      },

      body: JSON.stringify({ title, description, tag })
    });
    const json = response.json();
    console.log("adding a  nws note")
    const note = {
      "_id": "",
      "user": "",
      "title": title,
      "description": description,
      "tag": tag,
      "date": "",
      "__v": 0
    };
    setNotes(notes.concat(note))
  }
  //function to fetch all notes
  const fetchNote = async () => {
    //API CALL
    const response = await fetch(`${url}/api/notes/fetchallnotes`, {
      method: 'GET',
      headers: {
        'auth-token': localStorage.getItem('token')

      },


    });
    const json = await response.json();
    setNotes(json)
    
  }
  //function to update and edit a note
  // const editNote = async (id, title, description, tag) => {
  //   console.log("updating a note",id,title,description,tag)
  //   // function for api call
  //   try{
  //   const response = await fetch(`${url}/api/notes/updatenotes/${id}`, {  // cors error tells us that you cant made request to this api direct from browser
  //     // so in this case we have to install cors in backend npm i cors
  //     method: 'PUT',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'auth-token': localStorage.getItem('token')
  //     },

  //     body: JSON.stringify({ title, description, tag })
  //   });
  //   const json = await response.json();
  //   console.log(json)


  //  let newNotes=JSON.parse(JSON.stringify(notes))

  //   // to edit notes 
  //   for (let index = 0; index < notes.length; index++) {
  //     const element = newNotes[index];
  //     if (element._id === id) {
  //       newNotes[index].title = title;
  //       newNotes[index].description = description;
  //       newNotes[index].tag = tag;
  //       break;
  //     }

  //   }
  //   setNotes(newNotes);
  // }
  // catch(e){
  //   console.log('got follwoing error',e)
  // }
  // }
  const editNote = async (id, title, description, tag) => {
    console.log("updating a note", id, title, description, tag);
  
    try {
      const response = await fetch(`${url}/api/notes/updatenotes/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'auth-token': localStorage.getItem('token'),
        },
        body: JSON.stringify({ title, description, tag }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const updatedNote = await response.json();
      console.log(updatedNote);
  
      // Update the notes in the state
      setNotes((prevNotes) => {
        return prevNotes.map((note) => {
          if (note._id === id) {
            return {
              ...note,
              title: updatedNote.title,
              description: updatedNote.description,
              tag: updatedNote.tag,
            };
          }
          return note;
        });
      });
    } catch (error) {
      console.error('An error occurred while updating the note:', error);
  
      // You can handle the error here, e.g., show a notification to the user
    }
  };
  // function to delete a note
  const deleteNote = async (id) => {
    console.log("delete with id" + id)          // yaha pe notice aur kucch bhi daal skete hai kyoki filter function notes ko render kar raha
    // hai yaha ye filter krdega un notes ko jiski id props id ke equal nhi hai
   
    const response = await fetch(`${url}/api/notes/deletenotes/${id}`, {  // cors error tells us that you cant made request to this api direct from browser
      // so in this case we have to install cors in backend npm i cors
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': localStorage.getItem('token')
        
       
      },
      
    });
   
    const json = response.json()
    console.log(json)
    const newNote = notes.filter((notice) => { return notice._id !== id })
    setNotes(newNote)
  }
  return (
    <notesContext.Provider value={{ notes: notes, setNotes: setNotes, addNote, editNote, deleteNote, fetchNote }}>
      {props.children}
    </notesContext.Provider>
  )
}


export default NoteState;

